<template>
  <div class="actionPlan">
    <div class="show add assessmentAdd">
      <GradeDetail :id="gradeId" :getDatas="getGradeData"></GradeDetail>
      <div class="addBox">
        <div class="title">学科行动计划-评估</div>
        <ul class="showlist">
          <li v-for="(item,index) in data.subjectStress||[]" :key="index">
            <span>
              <img src="~@img/xueyezixun/public/star.png" alt="">
              {{index}}
            </span>
            <div class="scores">学期目标：{{item?item[0]['targetScore']:''}}</div>
            <div v-for="(it,i) in item" :key="i">
              <div>阶段问题{{it.length>1?i+1:""}}：{{it.stageProblem}}</div>
              <div>阶段任务{{it.length>1?i+1:""}}：{{it.stageTask}}</div>
              <div class="right">
                <div>任务完成：{{it.taskComplete}}
                </div>
                <div>完成效果：{{it.completeEffect}}
                </div>
              </div>
            </div>
          </li>
          <li v-for="(item,index) in data.subjectCommon||[]" :key="index">
            <span>
              {{index}}
            </span>
            <div class="scores">学期目标：{{item?item[0]['targetScore']:''}}</div>
            <div v-for="(it,i) in item" :key="i">
              <div>阶段问题{{it.length>1?i+1:""}}：{{it.stageProblem}}</div>
              <div>阶段任务{{it.length>1?i+1:""}}：{{it.stageTask}}</div>
              <div class="right">
                <div>任务完成：{{it.taskComplete}}
                </div>
                <div>完成效果：{{it.completeEffect}}
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div class="title">学习习惯养成</div>
        <div>
          <circleName :name="'阶段学习习惯养成评估:'"></circleName>
          <div class="habit">
            <table v-for="(item,index) in data.subjectLearnHabit||[]" :key="index">
              <tbody>
              <tr>
                <td>阶段问题:</td>
                <td>
                  {{item.stageProblem}}
                </td>
                <td>
                  <span></span>
                  任务完成：{{item.taskComplete}}
                </td>
              </tr>
              <tr>
                <td>目标习惯:</td>
                <td>
                  {{item.targetHabit}}
                </td>
                <td>
                  <span></span>
                  完成效果：{{item.completeEffect}}
                </td>
              </tr>
              <tr>
                <td>行动方案：</td>
                <td>
                  {{item.actionPlan}}
                </td>
                <td>
                  <span></span>
                  是否继续：
                  <el-radio v-model="item.isContinue" :label="1"  disabled style="padding-left: 30px">是</el-radio>
                  <el-radio v-model="item.isContinue" :label="2" disabled>否</el-radio>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="title" style="margin-top: 30px">路径条件</div>
        <div>
          <circleName :name="'条件目标:'+data.consultRecord"></circleName>
          <circleName :name="'路径目标任务评估:'"></circleName>
          <div class="habit">
            <table v-for="(item,index) in data.subjectPathCondition||[]" :key="index">
              <tbody>
              <tr>
                <td>阶段目标:</td>
                <td>
                  {{item.stageTarget}}
                </td>
                <td>
                  <span></span>
                  任务完成：{{item.taskComplete}}
                </td>
              </tr>
              <tr>
                <td>阶段任务:</td>
                <td>
                  {{item.stageTask}}
                </td>
                <td>
                  <span></span>
                  完成效果：{{item.completeEffect}}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div style="text-align: center;margin:40px 0">
      <Button name="返回" @handleClick="$router.push('/consultant/minestudent/main/implement/actionplan/list')"></Button>
    </div>
  </div>
</template>
<script>
import MessageTitle from '@/components/xueyezixun/MessageTitle.vue'
import CircleName from "@/components/xueyezixun/CircleName";
import SummaryTitle from "@/components/xueyezixun/SummaryTitle";
import Button from "@/components/xueyezixun/Button";
import GradeDetail from './gradeDetailassessment'

export default {
  name: 'actionPlan',
  components:{MessageTitle ,CircleName,SummaryTitle,Button,GradeDetail },
  data() {
    return {
      actionPlanId: this.$route.query.actionPlanId,
      gradeId: this.$route.query.gradeId,
      studentId:sessionStorage.getItem('myStudentStudentId'),
      data: {},
      subjects: [],
      interView: [{
        category: 4,
        interViewTheme: '行动计划评估'
      }],
      // popup_bool:true,
      popup_bool:false,
      interViewData:''
    }
  },
  methods: {
    getData(){
      this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.implement.detail, {
        id:this.$route.query.actionPlanId
      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          this.data=res.data.data
        }else{

        }
      })
    },
    getGradeData (obj) {
      this.subjects=obj.subject;
      let subjectStress = this.data.subjectStress;
      let subjectCommon = this.data.subjectCommon;
      if (subjectStress) {
        obj.subject.forEach(item => {
          Object.keys(subjectStress).forEach(key => {
            if (item.subject == key) {
              subjectStress[key][0].targetScore = item.targetScore
            }
          })
        })
      }
      if (subjectCommon) {
        obj.subject.forEach(item => {
          Object.keys(subjectCommon).forEach(key => {
            if (item.subject == key) {
              subjectCommon[key][0].targetScore = item.targetScore
            }
          })
        })
      }
      this.$set(this.data,'subjectStress',subjectStress)
      this.$set(this.data,'subjectCommon',subjectCommon)
      console.log(this.data.subjectStress)
    }
  },
  mounted() {
      this.getData()
  }
}
</script>
<style scoped lang="less">
  @import "./css/index.less";
</style>